import { combineReducers } from 'redux';

import { selectedOffer } from './offer/offer';

export const selected = combineReducers({
  offer: selectedOffer,
});
